// extracted by mini-css-extract-plugin
module.exports = {"container":"Projects_container__23tIQ","project":"Projects_project__22eSF"};